import '../../styles/templates/article.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Article Template');
});
